import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import { DependentDetails } from '@Types/common/DependentDetails';
import { EmergencyContact } from '@Types/common/EmergencyContact';
import { UserDetails } from '@Types/common/UserDetails';
import { parseDateTime } from '@Utils/transformDateTime';

type DataRow = {
  title: string;
  description: string;
};

export const prepareEmergencyContact = (
  emergencyContact: EmergencyContact | undefined
): DataRow[] => {
  return [
    {
      title: 'Name',
      description:
        emergencyContact?.emergencyContactName || EMPTY_FIELD_PLACEHOLDER,
    },
    {
      title: 'Phone Number',
      description:
        emergencyContact?.emergencyContactNo || EMPTY_FIELD_PLACEHOLDER,
    },
    {
      title: 'Relation',
      description: emergencyContact?.relation || EMPTY_FIELD_PLACEHOLDER,
    },
  ];
};

export const prepareEmployeeDetails = (
  employeeDetails: UserDetails | undefined,
  phone: string
): DataRow[] => {
  return [
    {
      title: 'Employee Full Name',
      description: employeeDetails?.empName || EMPTY_FIELD_PLACEHOLDER,
    },
    {
      title: 'Employee Number',
      description: employeeDetails?.empNumber || EMPTY_FIELD_PLACEHOLDER,
    },
    {
      title: 'Date of Joining',
      description:
        parseDateTime(employeeDetails?.joinDate || '') ||
        EMPTY_FIELD_PLACEHOLDER,
    },
    {
      title: 'Marital Status',
      description: employeeDetails?.maritalStatus || EMPTY_FIELD_PLACEHOLDER,
    },
    {
      title: 'Personal Phone Number',
      description: phone || EMPTY_FIELD_PLACEHOLDER,
    },
    {
      title: 'Gender',
      description: employeeDetails?.gender || EMPTY_FIELD_PLACEHOLDER,
    },
  ];
};

export const prepareDependentDetails = (
  dependentDetailsResp: DependentDetails[] | undefined
): DataRow[] => {
  if (!dependentDetailsResp || !dependentDetailsResp.length) {
    return [
      {
        title: 'Dependent No.',
        description: EMPTY_FIELD_PLACEHOLDER,
      },
      {
        title: 'Dependent Name',
        description: EMPTY_FIELD_PLACEHOLDER,
      },
      {
        title: 'Nationality',
        description: EMPTY_FIELD_PLACEHOLDER,
      },
      {
        title: 'DOB',
        description: EMPTY_FIELD_PLACEHOLDER,
      },
      {
        title: 'Emp No.',
        description: EMPTY_FIELD_PLACEHOLDER,
      },
      {
        title: 'Relation',
        description: EMPTY_FIELD_PLACEHOLDER,
      },
      {
        title: 'Gender',
        description: EMPTY_FIELD_PLACEHOLDER,
      },
    ];
  }

  const output = dependentDetailsResp
    .map((dependentItem) => {
      return [
        {
          title: 'Dependent No.',
          description: dependentItem.dependentNo || EMPTY_FIELD_PLACEHOLDER,
        },
        {
          title: 'Dependent Name',
          description: dependentItem.name || EMPTY_FIELD_PLACEHOLDER,
        },
        {
          title: 'Nationality',
          description: dependentItem.nationality || EMPTY_FIELD_PLACEHOLDER,
        },
        {
          title: 'DOB',
          description:
            parseDateTime(dependentItem.dob) || EMPTY_FIELD_PLACEHOLDER,
        },
        {
          title: 'Emp No.',
          description: dependentItem.empNumber || EMPTY_FIELD_PLACEHOLDER,
        },
        {
          title: 'Relation',
          description: dependentItem.relation || EMPTY_FIELD_PLACEHOLDER,
        },
        {
          title: 'Gender',
          description: dependentItem.gender || EMPTY_FIELD_PLACEHOLDER,
        },
      ];
    })
    .flat();

  return output;
};
